<mat-select [ngClass]="prefix ? 'phone-prefix': ''" #select
            [formControl]="selectionFormControl" [multiple]="multiple"
            [placeholder]="placeholder" (click)="loadItems()" (valueChange)="valueChange.emit($event)" (closed)="blurEvent.emit($event)"
            (selectionChange)="selectionChange.emit($event)">
  <mat-select-trigger class="mat-trigger" *ngIf="prefix">
    <img alt="flag"
         class="img-responsive img-flag-country"
         src="/assets/flags/{{prefix?.code.toLowerCase()}}.png"> +{{prefix?.phoneCode}}
  </mat-select-trigger>
  <mat-select-trigger class="mat-trigger" *ngIf="(allMatOption?.selected  || this.value?.length === this.totalItems?.length) && this.allOption">
    All
  </mat-select-trigger>
  <mat-option *ngIf="withFilter">
    <ngx-mat-select-search
      *ngIf="withFilter"
      [formControl]="searchFormControl"
      [noEntriesFoundLabel]="noEntriesFoundLabel ? noEntriesFoundLabel : 'Not found'"
      [placeholderLabel]="searchPlaceHolder ? searchPlaceHolder : 'Search...'">
    </ngx-mat-select-search>
  </mat-option>
  <mat-option *ngIf="allOption" #allMatOption [value]="0" (onSelectionChange)="selectAll($event)">All</mat-option>
  <mat-option (onSelectionChange)="onSelectionChange.emit($event)"
              *ngFor="let item of filteredItems | async"
              [value]="itemId ? item[itemId] : item"
              [disabled]="optionDisabled(item)"
              [hidden]="optionHidden(item)"
              (click)="!optionDisabled(item) && selectOne()">
    <ng-template ngFor let-item [ngForOf]="[item]" [ngForTemplate]="option">
    </ng-template>
  </mat-option>
</mat-select>

